// ProductView.js (ปรับแล้ว: แยกใช้คูปอง iOS/Android + ข้อความสำเร็จแยกตามระบบ + ใช้ arrayRemove แบบ atomic)

import React, { useState, useEffect } from "react";
import "bootstrap/dist/css/bootstrap.min.css";
import "./ProductView.css";

import {
  Container,
  Row,
  Col,
  Tabs,
  Tab,
  Button,
  Form,
  Modal,
  Card,
} from "react-bootstrap";

import { auth, firestore } from "../Database/firebase";

// ✅ ใช้ FieldValue.arrayRemove (atomic)
import firebase from "firebase/compat/app";
import "firebase/compat/firestore";

import { Link, useNavigate, useParams } from "react-router-dom";

import { BsStarFill, BsStarHalf, BsStar, BsPatchCheckFill } from "react-icons/bs";
import { FaFacebookMessenger } from "react-icons/fa";
import { BsFacebook, BsInstagram, BsYoutube, BsTiktok } from "react-icons/bs";

import edulaw_qrcode01 from "../component_home/asset/edulaw_qrcode01.jpg";

function ProductView() {
  let { productId } = useParams();

  const formatter = new Intl.NumberFormat("th", {
    style: "currency",
    currency: "THB",
    maximumSignificantDigits: 3,
  });

  const [data, setData] = useState([]);

  const [merchantID, setMerchantID] = useState("");
  const [productID, setProductID] = useState("");
  const [merchantName, setMerchantName] = useState("");
  const [productCaption, setProductCaption] = useState("");
  const [productCategory, setProductCategory] = useState("");
  const [productSubCategory, setProductSubCategory] = useState("");
  const [productTypeCategory, setProductTypeCategory] = useState("");
  const [productName, setProductName] = useState("");
  const [productDescription, setProductDescription] = useState("");
  const [productBadge, setProductBadge] = useState("");
  const [productFullPrice, setProductFullPrice] = useState("");
  const [productPrice, setProductPrice] = useState("");
  const [productDiscount, setProductDiscount] = useState("");
  const [productImage, setProductImage] = useState("");
  const [productPdf, setProductPdf] = useState("");
  const [pdfFilePath, setPdfFilePath] = useState("");
  const [productReciept, setProductReciept] = useState("");

  const [productRatingSum, setProductRatingSum] = useState(0);
  const [productRatingCount, setProductRatintCount] = useState(0);

  const [productRelease, setProductRelease] = useState("");
  const [productDate, setProductDate] = useState("");

  const [productType, setProductType] = useState("");
  const [productKeyword, setProductKeyword] = useState("");

  const [wishlist, setWishlist] = useState([""]);
  const [productSamplePdf, setProductSamplePdf] = useState("");
  const [saleCount, setSaleCount] = useState("");
  const [productWebPrice, setProductWebPrice] = useState("");

  // ✅ coupon arrays (คุณใช้ field นี้ร่วม iOS/Android ได้ตามที่บอก)
  const [couponcodeMerchantios, setCouponcodeMerchantios] = useState([""]);
  const [couponcodeUserios, setCouponcodeUserios] = useState([""]);

  // =========================
  // LOAD PRODUCT
  // =========================
  useEffect(() => {
    const productRef = firestore.collection("product");
    const query = productRef.where("productID", "==", productId);

    query.get().then(
      (querySnapshot) => {
        let tempDataArray = [];
        querySnapshot.forEach((doc) => {
          if (doc.exists) {
            tempDataArray = [...tempDataArray, {}];

            setProductID(doc.data().productID);
            setMerchantName(doc.data().merchantName);
            setMerchantID(doc.data().merchantID);
            setProductName(doc.data().productName);
            setProductCaption(doc.data().productCaption);
            setProductCategory(doc.data().productCategory);
            setProductSubCategory(doc.data().productSubCategory);
            setProductTypeCategory(doc.data().productTypeCategory);
            setProductBadge(doc.data().productBadge);
            setProductFullPrice(doc.data().productFullPrice);
            setProductPrice(doc.data().productPrice);
            setProductDiscount(doc.data().productDiscount);
            setProductImage(doc.data().productImage);
            setProductDescription(doc.data().productDescription);

            setProductRelease(doc.data().productRelease);

            setProductRatintCount(doc.data().productRatingCount);
            setProductRatingSum(doc.data().productRatingSum);

            setProductType(doc.data().productType);

            setSaleCount(doc.data().saleCount);

            setWishlist(doc.data().wishlist);

            setProductSamplePdf(doc.data().productSamplePdf);

            setPdfFilePath(doc.data().pdfFilePath);
            setProductPdf(doc.data().productPdf);

            setProductWebPrice(doc.data().productWebPrice);

            setProductKeyword(doc.data().productKeyword);

            setCouponcodeMerchantios(doc.data().couponcodeMerchantios || []);
            setCouponcodeUserios(doc.data().couponcodeUserios || []);
          }
        });

        setData((oldDataArray) => tempDataArray);
      },
      (err) => console.log(err)
    );
  }, [productId]);

  // =========================
  // QUERY MERCHANT DATA
  // =========================
  const [displayMerchantName, setDisplayMerchantName] = useState("");
  const [profileMerchantImg, setProfileMerchantImg] = useState("");
  const [description, setDescription] = useState("");
  const [facebook, setFacebook] = useState("");
  const [instagram, setInstagram] = useState("");
  const [youtube, setYoutube] = useState("");
  const [tiktok, setTiktok] = useState("");

  useEffect(() => {
    const userRef = firestore.collection("user");
    const query = userRef.where("uid", "==", merchantID);

    query.get().then(
      (querySnapshot) => {
        querySnapshot.forEach((doc) => {
          if (doc.exists) {
            setDisplayMerchantName(doc.data().displayName);
            setProfileMerchantImg(doc.data().profileImg);
            setDescription(doc.data().description);
            setFacebook(doc.data().facebook);
            setInstagram(doc.data().instagram);
            setYoutube(doc.data().youtube);
            setTiktok(doc.data().tiktok);
          }
        });
      },
      (err) => console.log(err)
    );
  }, [merchantID]);

  // =========================
  // AUTH USER
  // =========================
  const [displayName, setDisplayName] = useState("");
  const [profileImg, setProductImg] = useState("");

  const [displayNameShown, setDisplayNameShown] = useState(true);

  const [currentUser, setCurrentUser] = useState(null);

  var user = auth.currentUser;
  var email, uid, name;
  var hiddenEmail;

  if (user != null) {
    user.reload();
    uid = user.uid;
    email = user.email;
    name = user.displayName;

    hiddenEmail = email.charAt(0) + email.replace(/./g, "*") + email.charAt(email.length - 1);
  }

  useEffect(() => {
    const userRef = firestore.collection("user");

    if (!!uid) {
      const query = userRef.where("uid", "==", uid);
      query.get().then(
        (querySnapshot) => {
          querySnapshot.forEach((doc) => {
            if (doc.exists) {
              setDisplayName(doc.data().displayName);
              setProductImg(doc.data().profileImg);
            }
          });
        },
        (err) => console.log(err)
      );
    }
  }, [user]);

  useEffect(() => {
    if (displayNameShown) {
      setDisplayName(email);
    } else {
      setDisplayName(hiddenEmail);
    }
  }, [displayNameShown]);

  const navigate = useNavigate();

  const refreshPage = () => navigate(0);
  const signUpPage = () => navigate("/SignUp");

  // =========================
  // MODALS (QR)
  // =========================
  const [show2, setShow2] = useState(false);
  const handleClose2 = () => setShow2(false);
  const handleShow2 = () => setShow2(true);

  // =========================
  // COUPON UI (ใหม่)
  // =========================
  const [couponcodeIos, setCouponcodeIos] = useState("");
  const [couponcodeAndroid, setCouponcodeAndroid] = useState("");
  const [showCouponSection, setShowCouponSection] = useState(false);

  // modal: ยังไม่ login
  const [showSaleCouponCodeNotLogin, setShowSaleCouponCodeNotLogin] = useState(false);
  const handleCloseSaleCouponCodeNotLogin = () => setShowSaleCouponCodeNotLogin(false);

  // modal: สำเร็จ / ไม่ตรง
  const [showUseCouponCode, setShowUseCouponCode] = useState(false);
  const handleCloseUseCouponCode = () => setShowUseCouponCode(false);

  const [showNotMathCouponCode, setShowNotMathCouponCode] = useState(false);
  const handleCloseNotMathCouponCode = () => setShowNotMathCouponCode(false);

  // ✅ เก็บ platform ล่าสุด เพื่อแสดง “ข้อความสำเร็จ” ให้ตรงระบบ
  const [lastSuccessPlatform, setLastSuccessPlatform] = useState(""); // "webios" | "webAndroid"

  // ✅ modal ยืนยันก่อนใช้คูปอง (ใช้ร่วม iOS/Android)
  const [showConfirmUseCoupon, setShowConfirmUseCoupon] = useState(false);
  const [pendingPlatform, setPendingPlatform] = useState(""); // "webios" | "webAndroid"
  const [pendingCode, setPendingCode] = useState("");

  const handleCloseConfirmUseCoupon = () => setShowConfirmUseCoupon(false);

  const openConfirmUseCoupon = (platform, code) => {
    const cleaned = (code || "").trim();
    if (!cleaned) {
      setShowNotMathCouponCode(true);
      return;
    }
    setPendingPlatform(platform);
    setPendingCode(cleaned);
    setShowConfirmUseCoupon(true);
  };

  // =========================
  // LIBRARY: ใช้คูปอง + เพิ่มหนังสือ + ลบคูปอง (atomic)
  // =========================

  const stripDeviceFields = (obj) => {
    const copy = { ...obj };
    delete copy.deviceiPad;
    delete copy.deviceiPhone;
    delete copy.deviceTimestampiPad;
    delete copy.deviceTimestampiPhone;
    return copy;
  };

  const handleCouponAndGrantLibrary = async ({ platform, code }) => {
    try {
        if (!user || !uid) {
        setShowSaleCouponCodeNotLogin(true);
        return;
        }

        const cleaned = (code || "").trim();

        const exists = Array.isArray(couponcodeUserios) && couponcodeUserios.includes(cleaned);
        if (!exists) {
        setShowNotMathCouponCode(true);
        return;
        }

        // ✅ สร้าง id เดียวกันให้ library/order จะตามงานง่าย
        const libraryRef = firestore.collection("library").doc();
        const orderRef = firestore.collection("order").doc(libraryRef.id);
        const newId = libraryRef.id;

        // ✅ ชุดข้อมูลหลัก (เหมือนเดิม)
        const baseObj = {
        customerID: uid,
        displayName: displayName,
        profileImg: profileImg,

        productID: productID,
        orderID: newId, // ใช้ id เดียวกัน
        merchantID: merchantID,
        merchantName: merchantName,

        productImage: productImage,
        productName: productName,
        productCaption: productCaption,
        productCategory: productCategory,
        productSubCategory: productSubCategory,
        productTypeCategory: productTypeCategory,
        productBadge: productBadge,
        productFullPrice: productFullPrice,
        productPrice: productPrice,
        productWebPrice: productWebPrice,
        productDiscount: productDiscount,
        productDescription: productDescription,
        productRatingSum: productRatingSum,
        productRatingCount: productRatingCount,
        productRelease: productRelease,
        productDate: "",

        perchaseDate: new Date(),
        productPdf: productPdf,
        pdfFilePath: pdfFilePath,

        productReciept: productReciept,
        productType: productType,

        bookPlatform: platform, // "webios" | "webAndroid"

        readStatus: 1,
        readCount: 0,
        favoriteBook: 0,
        showInLibrary: 1,

        productKeyword: productKeyword,
        couponcode: cleaned,

        // ✅ fields นี้จะมีเฉพาะ library (order จะถูกลบทิ้ง)
        deviceiPad: "",
        deviceiPhone: "",
        deviceTimestampiPad: "",
        deviceTimestampiPhone: "",
        };

        // ✅ สร้าง obj สำหรับ order โดยตัด 4 ฟิลด์ device ออก
        const orderObj = stripDeviceFields(baseObj);

        // ✅ เขียน 2 collection + ลบคูปอง แบบ “ชุดเดียว” ด้วย batch (แนะนำสุด)
        const batch = firestore.batch();

        batch.set(libraryRef, baseObj);
        batch.set(orderRef, orderObj);

        batch.update(firestore.collection("product").doc(productID), {
        couponcodeUserios: firebase.firestore.FieldValue.arrayRemove(cleaned),
        });

        await batch.commit();

        // sync state
        setCouponcodeUserios((prev) => (prev || []).filter((x) => x !== cleaned));
        setCouponcodeIos("");
        setCouponcodeAndroid("");

        setLastSuccessPlatform(platform);

        handleCloseConfirmUseCoupon();
        setShowUseCouponCode(true);
    } catch (err) {
        console.log(err);
        handleCloseConfirmUseCoupon();
        setShowNotMathCouponCode(true);
    }
    };



  // =========================
  // READ MORE
  // =========================
  const [showMore, setShowMore] = useState(true);

  // =========================
  // COMMENTS (คงของเดิมตามที่คุณมี)
  // =========================
  const [commentLists, setCommentLists] = useState([]);
  const [currentCursor, setCurrentCursor] = useState("");

  useEffect(() => {
    const firsPageRef = firestore
      .collection("comment")
      .orderBy("commentDate", "desc")
      .where("productID", "==", productId)
      .limit(4);

    firsPageRef.onSnapshot((snapshot) => {
      let tempLists = [];
      snapshot.forEach((doc) => {
        if (doc.exists) {
          const currentComment = {
            id: doc.id,
            commentProduct: doc.data().commentProduct,
            commentRating: doc.data().commentRating,
            commentDate: doc.data().commentDate,
            displayName: doc.data().displayName,
            profileImg: doc.data().profileImg,
          };
          tempLists = [...tempLists, currentComment];
        }
      });

      setCommentLists((prv) => tempLists);
      const currentLenght = snapshot.docs.length;
      const currentCursorFromFirstPage = snapshot.docs[currentLenght - 1];
      setCurrentCursor(currentCursorFromFirstPage);
    });
  }, []);

  const onMoreComment = () => {
    const nextPageRef = firestore
      .collection("comment")
      .orderBy("commentDate", "desc")
      .where("productID", "==", productId)
      .limit(4);

    nextPageRef.onSnapshot((snapshot) => {
      const currentLenght = snapshot.docs.length;
      if (!currentCursor) return;

      const query = nextPageRef.startAfter(currentCursor);
      query.get().then((snapshot) => {
        let tempNewArray = [];
        snapshot.forEach((doc) => {
          if (doc.exists) {
            tempNewArray = [
              ...tempNewArray,
              {
                id: doc.id,
                commentProduct: doc.data().commentProduct,
                commentRating: doc.data().commentRating,
                commentDate: doc.data().commentDate,
                displayName: doc.data().displayName,
                profileImg: doc.data().profileImg,
              },
            ];
          }
        });

        setCommentLists([...commentLists, ...tempNewArray]);
        const currentCursorForNextPage = snapshot.docs[currentLenght - 1];
        setCurrentCursor(currentCursorForNextPage);
      });
    });
  };

  // =========================
  // RATING / COMMENT SUBMIT (คงของเดิมแบบย่อ)
  // =========================
  const id = "cmp" + Math.random(999).toString();
  const [comment, setComment] = useState("");
  const [rating, setRating] = useState(0);

  const [showNotRating, setShowNotRating] = useState(false);
  const handleCloseNotRating = () => setShowNotRating(false);
  const [showCommentSuccess, setShowCommentSuccess] = useState(false);
  const handleCloseCommentSuccess = () => setShowCommentSuccess(false);
  const [showCommentNotLogin, setShowCommentNotLogin] = useState(false);
  const handleCloseCommentNotLogin = () => setShowCommentNotLogin(false);

  const addCommentHandler = (obj) => {
    const ref = firestore.collection("comment");
    ref
      .doc(id)
      .set(obj)
      .then(() => console.log("เพิ่มข้อมูลสำเร็จ"))
      .catch((err) => console.log(err));
  };

  const ratingProductHandler = (obj) => {
    const ref = firestore.collection("product");
    ref
      .doc(productID)
      .update(obj)
      .then(() => console.log("แก้ไขข้อมูลสำเร็จ"))
      .catch((err) => console.log(err));
  };

  const submitCommentHandler = (e) => {
    e.preventDefault();

    const obj = {
      commentID: id,
      uid: uid,
      emailDisplay: email,
      merchantName: merchantName,
      displayName: displayName,
      profileImg: profileImg,
      merchantID: merchantID,
      productID: productID,
      productName: productName,
      productImage: productImage,
      productCategory: productCategory,
      productSubCategory: productSubCategory,
      productTypeCategory: productTypeCategory,

      commentProduct: comment,
      commentRating: rating,
      commentDate: new Date(),
    };

    if (rating == 0) {
      setShowNotRating(true);
      return;
    }

    if (uid != null) {
      addCommentHandler(obj);
      setRating(0);
      setComment("");
      setShowCommentSuccess(true);
    } else {
      setShowCommentNotLogin(true);
      return;
    }

    const objProduct = {
      productRatingSum: parseInt(productRatingSum) + parseInt(rating),
      productRatingCount: parseInt(productRatingCount) + parseInt(1),
    };

    ratingProductHandler(objProduct);
  };

  // =========================
  // RETURN UI
  // =========================
  return (
    <>
      <Container w-75x>
        <br />

        <Row>
          {/* Row 1 Product Image Left */}
          <Col className="text-center">
            <img className="img-fluid w-75 w-md-50 w-lg-25" src={productImage} alt="product" />
            <br />

            {!!productSamplePdf ? (
              <>
                <br />
                <div className="d-flex justify-content-center">
                  <a href={productSamplePdf} target="_blank" rel="noreferrer">
                    <Button variant="outline-primary rounded-pill" className="rounded-0">
                      ตัวอย่างหนังสือ
                    </Button>
                  </a>
                </div>
                <br />
              </>
            ) : null}
          </Col>

          <Col sm>
            <div className="border rounded p-3">
              <h4>
                <strong>{productName}</strong>
              </h4>

              <p>
                <strong>
                  <Link to={"/Category/" + productCategory} style={{ textDecoration: "none", color: "darkblue" }}>
                    {productCategory}
                  </Link>{" "}
                  {">"}{" "}
                  <Link to={"/SubCategory/" + productSubCategory} style={{ textDecoration: "none", color: "darkblue" }}>
                    {productSubCategory}
                  </Link>{" "}
                  {">"}{" "}
                  <Link to={"/TypeCategory/" + productTypeCategory} style={{ textDecoration: "none", color: "darkblue" }}>
                    {productTypeCategory}
                  </Link>
                </strong>
              </p>

              <p>
                ร้านค้า :{" "}
                <Link to={"/MerchantNameCategory/" + merchantID} style={{ textDecoration: "none", color: "dodgerblue" }}>
                  {merchantName}
                </Link>
                <br />
                ประเภทสินค้า : {productType}
                <br />
                วันที่ตีพิมพ์ : {productRelease}
                <br />

                {/* rating */}
                {(productRatingSum / productRatingCount) <= 0 ? (
                  <></>
                ) : (
                  <>
                    <span style={{ position: "relative", top: 3, fontWeight: "bolder", color: "goldenrod" }}>
                      {(parseFloat(productRatingSum) / parseFloat(productRatingCount)).toFixed(1)}
                    </span>{" "}
                    <span style={{ color: "orange", fontSize: 13 }}>
                      {/* แสดงดาวแบบเดิม */}
                      {(() => {
                        const avg = productRatingSum / productRatingCount;
                        if (avg <= 1) return <><BsStarFill /> <BsStar /> <BsStar /> <BsStar /> <BsStar /></>;
                        if (avg <= 1.5) return <><BsStarFill /> <BsStarHalf /> <BsStar /> <BsStar /> <BsStar /></>;
                        if (avg <= 2) return <><BsStarFill /> <BsStarFill /> <BsStar /> <BsStar /> <BsStar /></>;
                        if (avg <= 2.5) return <><BsStarFill /> <BsStarFill /> <BsStarHalf /> <BsStar /> <BsStar /></>;
                        if (avg <= 3) return <><BsStarFill /> <BsStarFill /> <BsStarFill /> <BsStar /> <BsStar /></>;
                        if (avg <= 3.5) return <><BsStarFill /> <BsStarFill /> <BsStarFill /> <BsStarHalf /> <BsStar /></>;
                        if (avg <= 4) return <><BsStarFill /> <BsStarFill /> <BsStarFill /> <BsStarFill /> <BsStar /></>;
                        if (avg <= 4.5) return <><BsStarFill /> <BsStarFill /> <BsStarFill /> <BsStarFill /> <BsStarHalf /></>;
                        return <><BsStarFill /> <BsStarFill /> <BsStarFill /> <BsStarFill /> <BsStarFill /></>;
                      })()}
                    </span>{" "}
                    <span style={{ position: "relative", top: 2, fontSize: 15 }}>
                      ({productRatingCount})
                    </span>
                  </>
                )}
              </p>

              <br />

              <h4>
                {formatter.format(productWebPrice)}{" "}
                <del style={{ color: "gray" }}>{formatter.format(productFullPrice)}</del>
              </h4>

              <p>
                <strong>ขายแล้ว:</strong>
                <span style={{ color: "green" }}> {saleCount}</span>
                <br />
              </p>

              <a
                href="https://www.facebook.com/profile.php?id=100028543045358&mibextid=LQQJ4d"
                target="_blank"
                rel="noreferrer"
              >
                <Button variant="dark" className="rounded-0">
                  <span style={{ color: "white" }}>ซื้อ Ebook</span>
                </Button>
              </a>

              <br />
              <br />

              <h3 className="pb-3 border-bottom"></h3>
              <br />

              <h4>วิธีการซื้อ Ebook</h4>
              <p style={{ color: "dodgerblue", fontWeight: "bold" }}>
                • กดซื้อ Ebook และแจ้งทางเพจ Facebook
                <br />
                • หรือชำระเงินโดยสแกนชำระผ่าน QrCode
                <br />
                • แจ้งทางเพจ Facebook และส่งหลักฐานชำระเงิน
                <br />
                • รับ Coupon Code เพื่อนำไปใช้อ่านหนังสือในแอพได้ทันที
                <br />
                • รองรับทั้ง iOS และ Android (เลือกใช้คูปองให้ตรงระบบ)
              </p>

              <Button variant="primary" className="rounded-0" onClick={handleShow2}>
                QrCode ชำระเงิน
              </Button>

              <Modal show={show2} onHide={handleClose2} centered>
                <Modal.Header closeButton>
                  <Modal.Title>QrCode ชำระเงิน</Modal.Title>
                </Modal.Header>
                <Modal.Body className="text-center">
                  <img src={edulaw_qrcode01} alt="QrCode ชำระเงิน" style={{ width: "60%", height: "auto" }} />
                </Modal.Body>
                <Modal.Footer>
                  <Button variant="secondary" onClick={handleClose2}>
                    ปิด
                  </Button>
                </Modal.Footer>
              </Modal>

              <br />
              <br />

              <h3 className="pb-3 border-bottom"></h3>
              <br />

              {/* =======================
                  ✅ COUPON SECTION (ใหม่)
                 ======================= */}
              <Form.Label>
                <strong>
                  <span style={{ fontSize: 25, color: "goldenrod" }}>
                    <BsPatchCheckFill />
                  </span>{" "}
                  ใช้ coupon code
                </strong>
              </Form.Label>

              <Button
                variant="outline-dark"
                className="rounded-0 w-100"
                onClick={() => setShowCouponSection((v) => !v)}
              >
                {showCouponSection ? "ซ่อนฟอร์มใช้ coupon code" : "กดเพื่อใช้ coupon code"}
              </Button>

              {showCouponSection && (
                <>
                  <br />

                  {/* iOS */}
                  <Card className="rounded-0">
                    <Card.Body>
                      <Form.Label>
                        <strong>ใช้ในระบบ iOS (iPhone / iPad)</strong>
                      </Form.Label>

                      <Form.Control
                        type="text"
                        className="rounded-0"
                        value={couponcodeIos}
                        placeholder="กรอก Coupon Code (iOS)"
                        onChange={(e) => setCouponcodeIos(e.target.value)}
                      />

                      <br />

                      {user ? (
                        <Button
                          variant="success"
                          className="rounded-0 w-100"
                          onClick={() => openConfirmUseCoupon("webios", couponcodeIos)}
                        >
                          ใช้ Coupon Code (iOS)
                        </Button>
                      ) : (
                        <Button
                          variant="success"
                          className="rounded-0 w-100"
                          onClick={() => setShowSaleCouponCodeNotLogin(true)}
                        >
                          ใช้ Coupon Code (iOS)
                        </Button>
                      )}
                    </Card.Body>
                  </Card>

                  <br />

                  {/* Android */}
                  <Card className="rounded-0">
                    <Card.Body>
                      <Form.Label>
                        <strong>ใช้ในระบบ Android</strong>
                      </Form.Label>

                      <Form.Control
                        type="text"
                        className="rounded-0"
                        value={couponcodeAndroid}
                        placeholder="กรอก Coupon Code (Android)"
                        onChange={(e) => setCouponcodeAndroid(e.target.value)}
                      />

                      <br />

                      {user ? (
                        <Button
                          variant="primary"
                          className="rounded-0 w-100"
                          onClick={() => openConfirmUseCoupon("webAndroid", couponcodeAndroid)}
                        >
                          ใช้ Coupon Code (Android)
                        </Button>
                      ) : (
                        <Button
                          variant="primary"
                          className="rounded-0 w-100"
                          onClick={() => setShowSaleCouponCodeNotLogin(true)}
                        >
                          ใช้ Coupon Code (Android)
                        </Button>
                      )}
                    </Card.Body>
                  </Card>

                  <br />

                  <p style={{ color: "goldenrod", fontWeight: "bold" }}>
                    • ใช้งาน Coupon Code เพื่ออ่านหนังสือผ่านแอพพลิเคชั่น EduLaw ได้ทันที
                    <br />
                    • เลือกระบบให้ตรงกับอุปกรณ์ที่ต้องการใช้งาน (iOS / Android)
                  </p>
                </>
              )}

              {/* =======================
                  MODALS: NOT LOGIN / CONFIRM / SUCCESS / FAIL
                 ======================= */}

              {/* not login */}
              <Modal
                show={showSaleCouponCodeNotLogin}
                onHide={handleCloseSaleCouponCodeNotLogin}
                animation={false}
                size="m"
                centered
              >
                <Modal.Header>
                  <Modal.Title>กรุณาเข้าสู่ระบบ</Modal.Title>
                </Modal.Header>

                <Modal.Body>
                  <Link
                    onClick={() => (window.location.href = "/LogIn")}
                    style={{ textDecoration: "none" }}
                  >
                    เข้าสู่ระบบ
                  </Link>{" "}
                  หรือ{" "}
                  <Link
                    onClick={() => (window.location.href = "/SignUp")}
                    style={{ textDecoration: "none" }}
                  >
                    สมัครสมาชิก
                  </Link>{" "}
                  เพื่อเข้าใช้งาน Coupon Code
                </Modal.Body>

                <Modal.Footer>
                  <Button variant="secondary" onClick={handleCloseSaleCouponCodeNotLogin}>
                    ตกลง
                  </Button>
                </Modal.Footer>
              </Modal>

              {/* confirm use coupon */}
              <Modal
                show={showConfirmUseCoupon}
                onHide={handleCloseConfirmUseCoupon}
                animation={false}
                size="m"
                centered
              >
                <Modal.Header>
                  <Modal.Title>ใช้ Coupon Code</Modal.Title>
                </Modal.Header>

                <Modal.Body>
                  ต้องการใช้ Coupon Code สำหรับหนังสือ <br/><strong>{productName}</strong>
                  <br />
                  ระบบ: <strong>{pendingPlatform === "webios" ? "iOS" : "Android"}</strong>
                  <br />
                  Coupon: <strong>{pendingCode}</strong>
                </Modal.Body>

                <Modal.Footer>
                  <Button variant="secondary" onClick={handleCloseConfirmUseCoupon}>
                    ยกเลิก
                  </Button>
                  <Button
                    variant="success"
                    onClick={() => handleCouponAndGrantLibrary({ platform: pendingPlatform, code: pendingCode })}
                  >
                    ใช้ Coupon Code
                  </Button>
                </Modal.Footer>
              </Modal>

              {/* success (✅ แยกข้อความตาม iOS/Android) */}
              <Modal
                show={showUseCouponCode}
                onHide={handleCloseUseCouponCode}
                animation={false}
                size="m"
                centered
              >
                <Modal.Header>
                  <Modal.Title>ใช้ Coupon Code สำเร็จ</Modal.Title>
                </Modal.Header>

                <Modal.Body>
                  {lastSuccessPlatform === "webAndroid" ? (
                    <>
                      สามารถอ่านหนังสือ <strong>{productName}</strong> ในระบบ <strong>Android</strong> ผ่านแอพพลิเคชั่น EduLaw ได้ทันที
                      <br />
                      หากมีข้อสงสัยสามารถสอบถามทีมงานได้ผ่านเพจ Facebook หรือทุกช่องทางการสื่อสาร
                    </>
                  ) : (
                    <>
                      สามารถอ่านหนังสือ <strong>{productName}</strong> ในระบบ <strong>iOS</strong> ผ่านแอพพลิเคชั่น EduLaw ได้ทันที
                      <br />
                      หากมีข้อสงสัยสามารถสอบถามทีมงานได้ผ่านเพจ Facebook หรือทุกช่องทางการสื่อสาร
                    </>
                  )}
                </Modal.Body>

                <Modal.Footer>
                  <Button variant="secondary" onClick={handleCloseUseCouponCode}>
                    ตกลง
                  </Button>
                </Modal.Footer>
              </Modal>

              {/* fail */}
              <Modal
                show={showNotMathCouponCode}
                onHide={handleCloseNotMathCouponCode}
                animation={false}
                size="m"
                centered
              >
                <Modal.Header>
                  <Modal.Title>ใช้ Coupon Code ไม่สำเร็จ</Modal.Title>
                </Modal.Header>

                <Modal.Body>
                  ไม่สามารถใช้ Coupon Code ได้ โปรดตรวจสอบข้อมูลเพื่อดำเนินการอีกครั้ง หากมีข้อสงสัยสามารถสอบถามทีมงานได้ผ่านเพจ Facebook หรือทุกช่องทางการสื่อสาร
                </Modal.Body>

                <Modal.Footer>
                  <Button variant="secondary" onClick={handleCloseNotMathCouponCode}>
                    ตกลง
                  </Button>
                </Modal.Footer>
              </Modal>

              <h3 className="pb-3 border-bottom"></h3>
              <a
                href="https://www.facebook.com/profile.php?id=100028543045358&mibextid=LQQJ4d"
                target="_blank"
                rel="noreferrer"
                style={{ textDecoration: "none", color: "tomato" }}
              >
                <p>
                  <FaFacebookMessenger /> แชทกับร้านค้า
                </p>
              </a>
            </div>
          </Col>
        </Row>

        <br />
        <br />

        {/* ร้านค้า */}
        <h3>
          <strong>ร้านค้า</strong>
        </h3>
        <Container>
          <Row className="border rounded p-3">
            <Col>
              <Row xs="auto">
                <Link to={"/MerchantNameCategory/" + merchantID} style={{ textDecoration: "none", color: "black" }}>
                  {!!profileMerchantImg ? (
                    <Col md="auto">
                      <img
                        src={profileMerchantImg}
                        alt="profile Image"
                        className="mr-3 mt-3"
                        style={{
                          borderRadius: "50%",
                          objectFit: "cover",
                          objectPosition: "center",
                          width: 70,
                          height: 70,
                          marginTop: 7,
                          marginLeft: -10,
                        }}
                      />
                    </Col>
                  ) : (
                    <Col>
                      <Button
                        variant="dark"
                        style={{ width: 70, height: 70, marginTop: 20, marginLeft: -10, fontSize: 20 }}
                        className="rounded-circle"
                      >
                        <strong>{(merchantName || "").slice(0, 1)}</strong>
                      </Button>
                    </Col>
                  )}
                </Link>

                <Col xs={9} md={7} style={{ marginTop: 20 }}>
                  <strong>{displayMerchantName}</strong>
                  <p style={{ lineHeight: 1.5 }}>{description}</p>
                </Col>
              </Row>
            </Col>

            <Col md={4}>
              <div className="float-end" style={{ marginTop: 20 }}>
                {facebook != "" ? (
                  <>
                    <a href={facebook} target="_blank" rel="noreferrer" style={{ textDecoration: "none", color: "black", fontSize: 20 }}>
                      <BsFacebook />
                    </a>
                    &nbsp;&nbsp;&nbsp;&nbsp;
                  </>
                ) : null}

                {instagram != "" ? (
                  <>
                    <a href={instagram} target="_blank" rel="noreferrer" style={{ textDecoration: "none", color: "black", fontSize: 20 }}>
                      <BsInstagram />
                    </a>
                    &nbsp;&nbsp;&nbsp;&nbsp;
                  </>
                ) : null}

                {youtube != "" ? (
                  <>
                    <a href={youtube} target="_blank" rel="noreferrer" style={{ textDecoration: "none", color: "black", fontSize: 20 }}>
                      <BsYoutube />
                    </a>
                  </>
                ) : null}

                {tiktok != "" ? (
                  <>
                    &nbsp;&nbsp;&nbsp;&nbsp;
                    <a href={tiktok} target="_blank" rel="noreferrer" style={{ textDecoration: "none", color: "black", fontSize: 20 }}>
                      <BsTiktok />
                    </a>
                  </>
                ) : null}
              </div>
            </Col>
          </Row>
        </Container>

        <br />
        <br />

        {/* Tabs */}
        <Tabs defaultActiveKey="detail" id="uncontrolled-tab-example" className="mb-3">
          <Tab eventKey="detail" title="รายละเอียด">
            <br />
            <h3>
              <strong>รายละเอียดสินค้า</strong>
            </h3>

            <strong>วันวางจำหน่าย:</strong> {productRelease}
            <br />

            <p style={{ whiteSpace: "pre-line" }}>
              {showMore
                ? <>{(productDescription || "").replaceAll("<br/>", "\n").substring(0, 500)} ...</>
                : (productDescription || "").replaceAll("<br/>", "\n")}
            </p>

            <Button variant="outline-dark" className="rounded-0" onClick={() => setShowMore(!showMore)}>
              {showMore ? "อ่านเพิ่มเติม" : "อ่านน้อยลง"}
            </Button>

            <br />
            <br />
          </Tab>

          <Tab eventKey="sample" title="วิธีการซื้อ Ebook">
            <br />
            <h3>
              <strong>วิธีการซื้อ Ebook</strong>
            </h3>

            <p>
              • กดซื้อ Ebook และแจ้งทางเพจ Facebook
              <br />
              • หรือชำระเงินโดยสแกนชำระผ่าน QrCode
              <br />
              • แจ้งทางเพจ Facebook และส่งหลักฐานชำระเงิน
              <br />
              • รับ Coupon Code เพื่อนำไปใช้อ่านหนังสือในแอพ EduLaw ได้ทันที
              <br />
              • รองรับทั้ง iOS และ Android (เลือกใช้คูปองให้ตรงระบบ)
            </p>

            <Button variant="primary" className="rounded-0" onClick={handleShow2}>
              QrCode ชำระเงิน
            </Button>

            <br />
          </Tab>
        </Tabs>

        <h3 className="pb-3 border-bottom"></h3>
        <br />

        {/* รีวิวสินค้า (คงเดิม) */}
        <h3>
          <strong>รีวิวสินค้า</strong>
        </h3>

        <br />

        {commentLists.map((item) => {
          return (
            <div key={item.id}>
              <Row xs="auto">
                <Col>
                  <Button
                    variant="dark"
                    style={{ width: 50, height: 50, marginTop: 7, fontSize: 20 }}
                    className="rounded-circle"
                  >
                    <strong>{(item.displayName || "").slice(0, 1)}</strong>
                  </Button>
                </Col>

                <Col xs={9} md={7} style={{ marginTop: 5 }}>
                  <strong>{item.displayName}</strong>
                  <br />

                  {item.commentRating == 5 ? (
                    <p style={{ color: "orange", fontSize: 15 }}>
                      <BsStarFill /> <BsStarFill /> <BsStarFill /> <BsStarFill /> <BsStarFill />
                    </p>
                  ) : item.commentRating == 4 ? (
                    <p style={{ color: "orange", fontSize: 15 }}>
                      <BsStarFill /> <BsStarFill /> <BsStarFill /> <BsStarFill /> <BsStar />
                    </p>
                  ) : item.commentRating == 3 ? (
                    <p style={{ color: "orange", fontSize: 15 }}>
                      <BsStarFill /> <BsStarFill /> <BsStarFill /> <BsStar /> <BsStar />
                    </p>
                  ) : item.commentRating == 2 ? (
                    <p style={{ color: "orange", fontSize: 15 }}>
                      <BsStarFill /> <BsStarFill /> <BsStar /> <BsStar /> <BsStar />
                    </p>
                  ) : (
                    <p style={{ color: "orange", fontSize: 15 }}>
                      <BsStarFill /> <BsStar /> <BsStar /> <BsStar /> <BsStar />
                    </p>
                  )}

                  <p style={{ position: "relative", top: -10, fontSize: 12 }}>
                    {item.commentDate?.toDate?.().toDateString?.()} | {item.commentDate?.toDate?.().toLocaleTimeString?.()}
                  </p>

                  <p style={{ whiteSpace: "pre-line", wordWrap: "break-word" }}>
                    {(item.commentProduct || "").replaceAll("<br/>", "\n")}
                  </p>
                </Col>
              </Row>

              <h3 className="pb-3 border-bottom"></h3>
              <br />
            </div>
          );
        })}

        {currentCursor ? (
          <Col className="float-start">
            <Button variant="warning" className="rounded-0" onClick={onMoreComment}>
              อ่านรีวิวเพิ่มเติม
            </Button>
          </Col>
        ) : (
          <Col className="float-start">
            <Button variant="outline-secondary" className="rounded-0" disabled>
              ไม่มีรีวิวสินค้า
            </Button>
          </Col>
        )}

        <br />
        <br />
        <br />
        <br />

        {!!user ? (
          <>
            <h3>
              <strong>เขียนรีวิว</strong>
            </h3>

            <form onSubmit={submitCommentHandler}>
              {/* stars (คงเดิมแบบเดิมที่สุด) */}
              {rating == 0 ? (
                <>
                  <Button onClick={() => setRating(1)} variant="none" style={{ color: "darkgray", fontSize: 25, marginLeft: -7 }} size="sm"><BsStar /></Button>
                  <Button onClick={() => setRating(2)} variant="none" style={{ color: "darkgray", fontSize: 25, marginLeft: -7 }} size="sm"><BsStar /></Button>
                  <Button onClick={() => setRating(3)} variant="none" style={{ color: "darkgray", fontSize: 25, marginLeft: -7 }} size="sm"><BsStar /></Button>
                  <Button onClick={() => setRating(4)} variant="none" style={{ color: "darkgray", fontSize: 25, marginLeft: -7 }} size="sm"><BsStar /></Button>
                  <Button onClick={() => setRating(5)} variant="none" style={{ color: "darkgray", fontSize: 25, marginLeft: -7 }} size="sm"><BsStar /></Button>
                </>
              ) : (
                <>
                  {[1,2,3,4,5].map((n) => (
                    <Button
                      key={n}
                      onClick={() => setRating(n)}
                      variant="none"
                      style={{ color: n <= rating ? "orange" : "darkgray", fontSize: 25, marginLeft: -7 }}
                      size="sm"
                    >
                      {n <= rating ? <BsStarFill /> : <BsStar />}
                    </Button>
                  ))}
                </>
              )}

              <br />
              <br />

              <p style={{ fontSize: 24 }}>{displayName}</p>

              <Form.Group className="mb-3" controlId="exampleForm.ControlTextarea1">
                <Form.Control
                  as="textarea"
                  className="rounded-0"
                  style={{ whiteSpace: "pre-line" }}
                  placeholder="รีวิว..."
                  rows={3}
                  value={comment}
                  onChange={(e) => setComment(e.target.value)}
                />
              </Form.Group>

              <Button variant="dark" className="rounded-0" type="submit">
                ส่งรีวิว
              </Button>
            </form>
          </>
        ) : (
          <Link to={"/LogIn"}>
            <Button variant="dark" className="rounded-0">
              เข้าสู่ระบบเพื่อรีวิว
            </Button>
          </Link>
        )}

        {/* Comment modals */}
        <Modal show={showNotRating} onHide={handleCloseNotRating} animation={false} size="m" centered>
          <Modal.Header>
            <Modal.Title>กรุณาให้คะแนนสินค้า</Modal.Title>
          </Modal.Header>
          <Modal.Body>กรุณาให้คะแนนโดยกดเลือกจำนวนดาวที่ต้องการก่อนส่งความคิดเห็น</Modal.Body>
          <Modal.Footer>
            <Button variant="secondary" onClick={handleCloseNotRating}>ตกลง</Button>
          </Modal.Footer>
        </Modal>

        <Modal show={showCommentSuccess} onHide={handleCloseCommentSuccess} animation={false} size="m" centered>
          <Modal.Header>
            <Modal.Title>ส่งความคิดเห็นสำเร็จ</Modal.Title>
          </Modal.Header>
          <Modal.Body>ขอบคุณสำหรับการให้คะแนนและความคิดเห็น</Modal.Body>
          <Modal.Footer>
            <Button variant="secondary" onClick={handleCloseCommentSuccess}>ตกลง</Button>
          </Modal.Footer>
        </Modal>

        <Modal show={showCommentNotLogin} onHide={handleCloseCommentNotLogin} animation={false} size="m" centered>
          <Modal.Header>
            <Modal.Title>กรุณาเข้าสู่ระบบ</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <Link onClick={() => (window.location.href = "/LogIn")} style={{ textDecoration: "none" }}>
              เข้าสู่ระบบ
            </Link>{" "}
            หรือ{" "}
            <Link onClick={() => (window.location.href = "/SignUp")} style={{ textDecoration: "none" }}>
              สมัครสมาชิก
            </Link>{" "}
            เพื่อแสดงความคิดเห็น
          </Modal.Body>
          <Modal.Footer>
            <Button variant="secondary" onClick={handleCloseCommentNotLogin}>ตกลง</Button>
          </Modal.Footer>
        </Modal>

        <br />
        <br />
        <br />
      </Container>
    </>
  );
}

export default ProductView;
